import type { Language } from '@wix/thunderbolt-becky-types'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { ICurrentLanguageAPI, MultilingualCurrentLanguageSymbol } from '@wix/thunderbolt-symbols'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'

const viewerManagerMultilingualApiFactory = (
	currentLanguage: ICurrentLanguageAPI
): IViewerManagerImplementor<'multiLingual'> => {
	return {
		multiLingual: {
			getCurrentLanguage: () => {
				return currentLanguage.get().languageCode
			},
			setCurrentLanguage: (languageCode: Language) => {
				currentLanguage.set(languageCode)
			},
		},
	}
}

export const ViewerManagerMultilingualApi = withDependencies(
	[MultilingualCurrentLanguageSymbol],
	viewerManagerMultilingualApiFactory
)
